import React from 'react';
import { useNavigate } from 'react-router';
import type { IObjectTreeIcon } from '../../../../common/src/domain/object/IObjectTreeIcon';
import { useTranslate } from '../../mixins/translate/translate';

export interface IConfirmLinkProps {
    text?: undefined | string;
    title?: undefined | string;
    showConfirm?: undefined | boolean;
    confirmText?: undefined | string;
    to?: undefined | string;
    dispatch?: undefined | ((prop: any) => void);
    onClick?: undefined | ((e: React.MouseEvent<any>) => void);
    className?: undefined | string;
    icons?: undefined | IObjectTreeIcon[];
}

export function ConfirmLink(props: IConfirmLinkProps) {
    const translate = useTranslate();
    const navigateUrl = useNavigate();

    function navigate(e: React.MouseEvent<any>) {
        let shouldNavigate = true;

        if (props.showConfirm) {
            shouldNavigate = confirm(props.confirmText);
        }

        if (shouldNavigate) {
            if (props.to) {
                e.preventDefault();
                navigateUrl(props.to);
            } else if (props.onClick) {
                props.onClick(e);
            }
        }
    }

    return (
        <a className={props.className} href="#" aria-expanded="true" onClick={(e) => navigate(e)} title={props.title}>
            {props.text}
            {props.icons &&
                props.icons.map((icon, i) => (
                    <span
                        key={i}
                        className={`fa ${icon.iconName} pl5 fw200 icon-${icon.severity}`}
                        style={{ color: icon.color, backgroundColor: icon.backgroundColor }}
                        title={icon.titleKey ? translate(icon.titleKey) : undefined}
                    ></span>
                ))}
        </a>
    );
}
